import React from 'react'
import PropTypes from 'prop-types'
import {GlgTableRow, GlgTableCell} from 'SharedComponents'
import { FaIcon } from '../../shared/components'

const Handle = ({...props}) => {
  return (
    <span {...props}>
      <FaIcon icon='bars' />
    </span>
  )
}

const sideBysideRowComponent = ({columns, removeLine, ...props}) => {
  return (
    <GlgTableRow { ...props}>
      { columns.map( column => {
          if (column === 'drag') {
            return <GlgTableCell key={column}><Handle { ...props.dragHandleProps } /></GlgTableCell>
          } else if (column === 'actions') {
            return (
              <GlgTableCell key={column}>
                { props.empty ? '' : <a className='force_red' onClick={() => removeLine(props.position, props.front9)}>Hide</a> }
              </GlgTableCell>
            )
          } else {
            return <GlgTableCell key={column}>{props.empty ? '' : props[`${column}`]}</GlgTableCell>
          }
        })
      }
    </GlgTableRow>
  )
}

sideBysideRowComponent.propTypes = {
  columns: PropTypes.array,
  dragHandleProps: PropTypes.object,
  empty: PropTypes.bool,
  removeLine: PropTypes.func,
  position: PropTypes.number,
  front9: PropTypes.bool,
}

export default sideBysideRowComponent
